import { FC } from 'react';
import StudentAllocateLedger from './StudentAllocateLedger';
import UseStudentAllocateLedger from './UseStudentAllocateLedger';

const StudentAllocateLedgerContainer: FC = () => {
  return <StudentAllocateLedger {...UseStudentAllocateLedger()} />;
};

export default StudentAllocateLedgerContainer;
